import { AbstractControl, Validator, ValidatorFn } from '@angular/forms';
import { ValorizationEdit } from '../model/valorization-edit';
export function ValidateValorizationEdit(control: AbstractControl) {

  if (!control.value || control.value === '' || typeof control.value === 'string') {
    return { validValorization: true };
  }

  const valorizationEdit = <ValorizationEdit>control.value;

  const procedures = valorizationEdit.ValorizationAmount
    .ValorizationItemsAmount.map(v =>v.ValorizationItem.MedicalAppointmentProcedure);

 const indexPrincipal = procedures.findIndex(p => p.Quantity > 0 && p.MedicalAppointmentProcedureTypeId === 1);
 if (indexPrincipal < 0) {
  return { validValorizationPrincipal: true, valorizationErrorDescription:
    'No ha ingresado una práctica principal' };
 } else  if (!valorizationEdit.ValorizationAmount.Valorization.AliquotTax) {
    return { validValorization: true, valorizationErrorDescription:
      'No ha ingresado el tipo de plan' };
 } else {
   return null;
 }
}

export function RequiredCoverageValidator(isSetSupplieEdition: boolean, isPracticeCoverage: boolean): ValidatorFn {
  return (control: AbstractControl): { [key: string]: boolean } | null => {
      if (control.value === null && isSetSupplieEdition && !isPracticeCoverage) {
          return { 'requiedCoverage': true };
      }

      if (control.value === null && !isSetSupplieEdition && isPracticeCoverage) {
        return { 'requiedCoverage': true };
      }

      return null;
  };
}

export function RequiredAmountValidator(canEditAmount: boolean): ValidatorFn {
  return (control: AbstractControl): { [key: string]: boolean } | null => {
      if (control.value === null && canEditAmount) {
          return { 'requiedAmount': true };
      }
      return null;
  };
}
